<div *ngIf="loading" class="container" [ngClass]="{ inline: inline, container: !fullScreen, overlay: fullScreen }">
  <p-progressSpinner [style]="{ height: size, width: size }" class="spinner"></p-progressSpinner>
</div>
